const Builder = require('../BuilderBase');

module.exports = class ToUpperCase extends Builder {
    constructor(properties) {
        super('transform_ToUpperCase', '', properties);
    }
};
